import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {distinctUntilChanged} from 'rxjs/operators';


export enum PilotFeature {
  ONLY_FOR_TESTING = 'ONLY_FOR_TESTING',
  REDESIGN_HOMEPAGE = 'REDESIGN_HOMEPAGE'
}

export interface BusinessPartner {
  id: number | undefined;
  hknrs: number[] | undefined;
}

@Injectable({
  providedIn: 'root'
})
export class AppStateService {

  private readonly activePilotFeaturesStore = new BehaviorSubject<PilotFeature[]>([]);

  readonly activePilotFeatures$ = this.activePilotFeaturesStore.asObservable();

  get activePilotFeatures(): PilotFeature[] {
    return this.activePilotFeaturesStore.getValue();
  }

  set activePilotFeatures(val: PilotFeature[]) {
    this.activePilotFeaturesStore.next(val);
  }


  private readonly isPersonalizedStore = new BehaviorSubject<boolean>(false);

  readonly isPersonalized$ = this.isPersonalizedStore.asObservable();

  get isPersonalized(): boolean {
    return this.isPersonalizedStore.getValue();
  }

  set isPersonalized(val: boolean) {
    this.isPersonalizedStore.next(val);
  }


  private readonly activeBusinessPartnerStore = new BehaviorSubject<BusinessPartner>({id: undefined, hknrs: undefined});

  readonly activeBusinessPartner$ = this.activeBusinessPartnerStore.asObservable();

  get activeBusinessPartner(): BusinessPartner {
    return this.activeBusinessPartnerStore.getValue();
  }

  set activeBusinessPartner(val: BusinessPartner) {
    this.activeBusinessPartnerStore.next(val);
  }

  private readonly isPersonalProductChangeFilterStore = new BehaviorSubject<boolean>(false);

  readonly isPersonalProductChangeFilter$ = this.isPersonalProductChangeFilterStore.asObservable().pipe(distinctUntilChanged());

  get isPersonalProductChangeFilter(): boolean {
    return this.isPersonalProductChangeFilterStore.getValue();
  }

  set isPersonalProductChangeFilter(val: boolean) {
    this.isPersonalProductChangeFilterStore.next(val);
  }

  private readonly isPersonalDeliveryFilterStore = new BehaviorSubject<boolean>(false);

  readonly isPersonalDeliveryFilter$ = this.isPersonalDeliveryFilterStore.asObservable().pipe(distinctUntilChanged());

  get isPersonalDeliveryFilter(): boolean {
    return this.isPersonalDeliveryFilterStore.getValue();
  }

  set isPersonalDeliveryFilter(val: boolean) {
    this.isPersonalDeliveryFilterStore.next(val);
  }

}
